var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMbsSkyBlob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 874,
    height: 723,
    viewBox: "0 0 874 723",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M682.698 81.2667C761.101 130.63 842.519 196.447 866.643 279.747C889.761 364.075 855.586 465.887 803.318 553.3C750.044 640.714 676.667 713.73 598.265 721.957C519.862 731.213 435.428 676.708 340.943 643.799C246.458 610.89 141.921 601.635 75.5806 540.959C9.23994 480.284 -17.8994 369.217 12.2554 281.804C42.4102 195.419 130.864 131.658 213.288 83.3234C295.711 33.9605 372.103 0.0234338 448.496 0.0234338C525.893 -1.00496 603.29 31.9037 682.698 81.2667Z",
    fill: "url(#paint0_linear_5438_27414)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5438_27414",
    x1: 0,
    y1: 723,
    x2: 710.187,
    y2: -135.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB6843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F1EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbsSkyBlob);
export default __webpack_public_path__ + "static/media/MBS_sky_blob.aafab8667b91449cf37fd6c471f5074b.svg";
export { ForwardRef as ReactComponent };